/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react'
import PropTypes from 'prop-types'
import { SlaContainer, SlaBadge, SlaText } from './styles'

const Badge = ({ sla }) => {
    if (sla) {

        const { today, operationDate } = sla
        
        const msDay = 1000 * 60 * 60 * 24;
        const dateDiffInDay = (date1, date2) => {
            const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
          
            return Math.floor((utc2 - utc1) / msDay);
        }

        const daysDiff = dateDiffInDay(new Date(operationDate), new Date(today));

        return (
            <SlaContainer>
                <SlaBadge daysDiff={daysDiff}/>
                <SlaText>{`${daysDiff} / 20`}</SlaText>
            </SlaContainer>
        )
    }

}

Badge.propTypes = {
    sla: PropTypes.object,
}

export default Badge;